import { AdobeMethods } from '../../../../services/adobe-launch/adobe-launch.methods';
import { AdobeAnalyticsProcessStep } from '../../../../services/adobe-launch/adobe-launch.process';
import { AnalyticsCtaType } from '../../../../services/adobe-launch/adobe-launch.cta';

export const configData = {
    adobeCopyPinInfoOnly: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    location: AdobeAnalyticsProcessStep.GAF_UNIQUE_KEY_SUCCESS_INFO,
                    ctaName: AdobeAnalyticsProcessStep.GAF_COPY_PIN,
                    ctaType: AnalyticsCtaType.BUTTON,
                },
            ],
        },
    ],
    adobeCopyPinLimited: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    location: AdobeAnalyticsProcessStep.GAF_UNIQUE_KEY_SUCCESS_LIMITED,
                    ctaName: AdobeAnalyticsProcessStep.GAF_COPY_PIN,
                    ctaType: AnalyticsCtaType.BUTTON,
                },
            ],
        },
    ],
};
